import { UserSummaryType } from '../../../../api/types/user/user-summary.type';
import { toast } from 'react-toastify';
import appApi from '../../../../api/app-api';
import globalCourseStore from '../../../../stores/global-course-store';
import { LecturerType } from '../../../../api/types/programs/course/lecturers/course-lecturer';

export const addNewCourseLectures = async (
  programId: number | undefined,
  courseId: number | undefined,
  selectedUsers: UserSummaryType[],
  setLoading: (loading: boolean) => void,
  setDialogActive: (active: boolean) => void,
) => {
  try {
    if (!programId || !courseId) {
      toast.warn('לא ניתן לאתר את מזהה הקורס ו/או התוכנית, נסה שוב מאוחר יותר');
      return;
    }
    if (selectedUsers.length === 0) {
      toast.warn(`תחילה יש לבחור מרצה`);
    }
    const uniqueIds = [...new Set(selectedUsers.map((user) => user.id))];
    setLoading(true);
    await appApi.addLecturesToCourse(programId, courseId, uniqueIds);

    // Update the state
    const lecturerData: LecturerType[] = selectedUsers.map((item) => ({
      ...item,
      scheduledTeachingHours: 0,
      completedTeachingHours: 0,
    }));

    globalCourseStore.addLecturers(lecturerData);

    toast.success('הפעולה התבצעה בהצלחה');
    setLoading(false);
    setDialogActive(false);
  } catch (e) {
    setLoading(false);
    toast.error('התרחשה תקלה, נסה שוב בעוד מספר רגעים');
    console.error(`addNewCourseLectures is failed with the error: ${e}`);
  }
};
